module.exports = __webpack_public_path__ + "media/images/puzzle/puzzle_71-5965f2535fb4c6a26d50f2a492b01527.png";